<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid container-p-x pb-3 bg-black footer-padding pt-3">
      <b-row class="p-md-0 p-2">
        <b-col class="col-md-6 col-12">
          <b-row class="background-logo w-md-75" @click="goHome">
            <b-col class="pt-3">
              <img src="../assets/logos/dvr.png"
               class="py-2 mx-2 pb-4 w-75">
           </b-col>
           <b-col>
              <img src="../assets/logos/rtg.png"
              class="py-2 mx-2 pb-4 w-75">
            </b-col>
          </b-row>
          <b-row>
            <p class="w-md-75 d-inline-block text-justify px-md-3 mt-3">
            Bem-vindo ao nosso web site. Nós, do Grupo DVR-RTG Engenharia prezamos
            pela execução de contratos e todos os procedimenos operacionais, em
            padrões que atendam às necessidades de seus clientes, comprometidos
            com a qualidade, meio-ambiente, segurança e saúde de seus colaboradores,
            sustentabilidade e responsabilidade social.
            </p>
          </b-row>
        </b-col>

        <b-col class="col-md-3 col-12" >
          <h5>Contato</h5>
          <b-row class="text-left">
            <b-col class="col-2 col-md-1">
              <img src="../assets/footer/fax.png" alt="icone de fax" />
            </b-col>
            <b-col class="col-10 col-md-8 ml-md-3">
              <p>Fax.: 0xx21 2425-5545<br>
                3833-1384
              </p>
            </b-col>
          </b-row>
          <b-row class="text-left">
            <b-col class="col-2 col-md-1">
              <img src="../assets/footer/phone.png" alt="icone de telefone" />
            </b-col>
            <b-col class="col-10 col-md-8 ml-md-3">
              <p>
                Cel.: (21) 98132-8528<br>
                (21) 96011-1111
              </p>
            </b-col>
          </b-row>
          <b-row class="text-left">
            <b-col class="col-2 col-md-1">
              <img src="../assets/footer/email.png" alt="icone de email" />
            </b-col>
            <b-col class="col-10 col-md-8 ml-md-3">
              <p>Email: daviramalho@dvrengenharia.com
              contato@dvrengenharia.com
              </p>
            </b-col>
          </b-row>
        </b-col>

        <b-col class="col-md-3 col-12" >
          <h5>Endereço</h5>
          <b-row class="text-left">
            <b-col class="col-2 col-md-1">
              <img src="../assets/footer/address.png" alt="icone de endereço" />
            </b-col>
            <b-col class="col-10 col-md-8 ml-md-3">
              <p>
                Rua Claudino Barata, nº 50 sl: 102
                Bairro Realengo, Rio de Janeiro - RJ
                CEP.21770-200
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',
  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    },
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Roboto:500&display=swap');

  h5, p {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    color: white;
  }

  h5 {
    font-size: 1.2rem;
  }

  .bg-black {
    background-color: black;
  }

  @media (min-width: 768px) {
    .w-md-75 {
      width: 75% !important;
    }
  }

.background-logo {
background-color: white;
border-radius: 46px 46px 46px 46px;
-moz-border-radius: 46px 46px 46px 46px;
-webkit-border-radius: 46px 46px 46px 46px;
border: 2px solid #a3a3a3;
}
</style>
